import { AgTechActionButton } from "@agtech/web/components/Buttons/AgTechButtons";
import AgTechGrid from "@agtech/web/components/Grids/AgTechGrid";
import AgTechGridLink from "@agtech/web/components/Grids/Controls/AgTechGridLink";
import { AgTechGridPropsModifier, gridItems } from "@agtech/web/components/Grids/Data/AgTechGridProps";
import { AgTechMoneyFormatter } from "@agtech/web/utilities/AgTechUtilities";
import InvoiceInfoDialog from "../../dialogs/InvoiceInfoDialog";
import InvoiceActionMenu from "../menus/InvoiceActionMenu";
import { SaleContactGridLink } from "../../../contacts/components/buttons/SaleContactButtons";
import { InvoiceInfo } from "@sales/data/invoicing/InvoicingData";
import { AgTechQueryBuilder } from "@agtech/core/data/queries/AgTechDataQueries";
import { getContactFullName } from "@agtech/data/contacts/ContactData";

export type InvoiceUnpaidInvoicesGridProps = {
    title?: string,
    invoices: InvoiceInfo[],
    renderPaymentsButton?: boolean,
    modifyGridProps?: AgTechGridPropsModifier<InvoiceInfo>
}

const InvoiceGrid = (props: InvoiceUnpaidInvoicesGridProps) => {
    return (
        <AgTechGrid
            data={{
                itemQuery: gridItems(props.invoices)
            }}
            header={{
                title: props.title ?? 'Invoices'
            }}
            columns={[
                {
                    header: "Invoice",
                    value: invoice => (
                        <AgTechGridLink
                            content={'#' + invoice.invoiceNumber}
                            onClick={e => InvoiceInfoDialog.Open(e, {
                                invoiceId: invoice.id,
                                showNextSteps: true
                            })}
                        />
                    ),
                    classes: 'bg-slate-100 emphasized centered',
                    width: '100px'
                },
                {
                    header: 'Bidder Number',
                    value: invoice => {
                        return invoice.contactBidder?.bidder?.bidderNumber ?? 'N/A';
                    },
                    width: '130px'
                },
                {
                    header: "Purchaser",
                    value: invoice => {
                        return (
                            <SaleContactGridLink
                                contactId={invoice.contactBidder?.id}
                                contactName={getContactFullName(invoice.contactBidder)}
                            />
                        )
                    },
                    size: 1.5
                },
                {
                    header: "Lots",
                    value: invoice => <AgTechGridLink content={invoice.numberOfLots.toString()} />,
                    width: '80px'
                },
                {
                    header: "Invoice Total",
                    value: invoice => <AgTechGridLink content={AgTechMoneyFormatter.format(invoice.invoiceTotal)} />,
                    width: '130px'
                },
                // {
                //     header: 'View',
                //     value: invoice => (
                //         <InvoiceInfoDialog.Button
                //             invoiceId={invoice.id}
                //             classes='button-link'
                //             text='View Invoice'
                //             showNextSteps={props.renderPaymentsButton ?? false}
                //         />
                //     ),
                //     showHeader: false,
                //     width: '140px'
                // }
            ]}
            isRowEntityTheSame={() => {
                return false;
            }}
            searchConfig={{
                options: [
                    {
                        field: 'Bidder Number',
                        value: invoice => invoice.invoiceNumber
                    },
                    {
                        field: 'Purchaser',
                        value: invoice => getContactFullName(invoice.contactBidder)
                    },
                    {
                        field: 'Invoice Total',
                        value: invoice => invoice.invoiceTotal.toString() + '_' + AgTechMoneyFormatter.format(invoice.invoiceTotal)
                    }
                ]
            }}
            actions={{
                rendering: invoice => (
                    <AgTechActionButton classes='stretched centered container'>
                        <InvoiceActionMenu invoice={invoice} />
                    </AgTechActionButton>
                )
            }}
            propModifier={props.modifyGridProps}
        />
    )
}

export default InvoiceGrid